import { h, Host } from "@stencil/core";
/**
 * Punches a hole through all parent shadow DOMs into the light DOM.
 * Any slotted chlid will be moved into the light, and a chain of slots
 * brings the slotted children back into position.
 */
export class EsHolePuncher {
  constructor() {
    this.slotChain = [];
    this.slottedElements = [];
    this.namePrefix = 'hole';
  }
  componentWillLoad() {
    this.uniqueId = `${this.namePrefix}-${Math.random()
      .toString(16)
      .slice(2)}`;
  }
  componentDidLoad() {
    let $parent = this.host;
    let $host = $parent.getRootNode().host;
    while ($host) {
      const $slot = document.createElement('slot');
      $slot.setAttribute('name', this.uniqueId);
      $slot.setAttribute('slot', this.uniqueId);
      $parent.appendChild($slot);
      this.slotChain.push($slot);
      $parent = $host;
      $host = $parent.getRootNode().host;
    }
    const $slot = this.host.shadowRoot.querySelector('slot');
    if (!$slot)
      throw new Error('No slot found');
    $slot
      .assignedNodes({ flatten: true })
      .filter(($node) => $node.nodeType === Node.ELEMENT_NODE)
      .forEach(($el) => {
      $el.setAttribute('slot', this.uniqueId);
      $parent.appendChild($el);
      this.slottedElements.push($el);
    });
  }
  disconnectedCallback() {
    this.slotChain.forEach(($slot) => $slot.remove());
    this.slotChain = [];
    const $slot = this.host.shadowRoot.querySelector('slot');
    this.slottedElements.forEach(($node) => {
      $slot?.appendChild($node);
    });
    this.slottedElements = [];
  }
  render() {
    return (h(Host, null, h("slot", null), h("slot", { name: this.uniqueId })));
  }
  static get is() { return "es-hole-puncher"; }
  static get encapsulation() { return "shadow"; }
  static get properties() {
    return {
      "namePrefix": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Prefix the generated slot name, to allow easier identification in the DOM"
        },
        "attribute": "name-prefix",
        "reflect": false,
        "defaultValue": "'hole'"
      }
    };
  }
  static get elementRef() { return "host"; }
}
//# sourceMappingURL=es-hole-puncher.js.map
